import {environment} from '../../environments/environment';
import { Injectable } from "@angular/core";

@Injectable()
export class ApiRoutes {
  readonly LOGIN: string = environment.apiUrl + 'backend/token/requestToken';
  readonly REFRESH_TOKEN: string = environment.apiUrl + 'backend/token/refreshToken';
  readonly SET_PASSWORD_GET_USER_BY_CONFIRMATION_CODE: string = environment.apiUrl + 'backend/account/getLoginByConfirmationCode';
  readonly RESET_PASSWORD_GET_USER_BY_PASSWORD_RESSET_CODE: string = environment.apiUrl + 'backend/account/getLoginByPasswordResetCode';
  readonly SET_PASSWORD: string = environment.apiUrl + 'backend/account/setPassword';
  readonly RESET_PASSWORD: string = environment.apiUrl + 'backend/account/resetPassword';
  readonly ERROR_LOG: string = environment.apiUrl + 'backend/errorHandler';
  readonly FORGOT_PASSWORD: string = environment.apiUrl + 'backend/account/forgotPassword';
  readonly LOCATION_TEMPLATES: string = environment.apiUrl + 'backend/location/templatesLocation';
  readonly SUPPORTED_LANGUAGES: string = environment.apiUrl + 'backend/Translations/supportedcultures';
  readonly SET_CULTURE: string = environment.apiUrl + 'backend/account/setCulture';
  readonly GET_JOB_DETAIL: string = environment.apiUrl + 'backend/action/{0}';
  readonly ACCEPT_JOB: string = environment.apiUrl + 'backend/action/{0}/accept';
  readonly COMPLETE_JOB: string = environment.apiUrl + 'backend/action/{0}/complete';
  readonly ACCEPT_ALL_JOB: string = environment.apiUrl + 'backend/action/accept-all';
  readonly COMPLETE_ALL_JOB: string = environment.apiUrl + 'backend/action/complete-all';
  readonly GET_JOBS: string = environment.apiUrl + 'backend/action';
  readonly GET_INTERVENTION_TEAMS: string = environment.apiUrl + 'backend/InterventionTeam';
  readonly GET_BUILDINGS_WITH_ACTIONS: string = environment.apiUrl + 'backend/Building/Actions';
  readonly GET_BUILDING_DETAIL: string = environment.apiUrl + 'backend/Building/{0}';
  readonly GET_BUILDING_INTERVENTIONTEAMS: string = environment.apiUrl + 'backend/Building/{0}/InterventionTeams';
  readonly TRANSLATION: string = environment.apiUrl + 'backend/translations/';
  readonly LANGUAGES: string = environment.apiUrl + 'backend/translations/availableLanguages';
  readonly GET_JOB_CONTACTS: string = environment.apiUrl + 'backend/Contact/forAction/{0}';
  readonly MANIFEST: string = environment.apiUrl + 'backend/manifest/{0}';
  readonly BUILDING_STRUCTURES: string = environment.apiUrl + 'backend/structure'
  readonly BUILDING_STRUCTURES_ELEMENTS: string = environment.apiUrl + 'backend/structure/{0}'
  readonly ADD_ISSUE: string = environment.apiUrl + 'backend/issue'
  readonly GET_BUILDINGS: string = environment.apiUrl + 'backend/Building';

  public getRouteWithInjectedParams(route: string, values: string[]): string {
    let result: string = route;
    for (let i = 0; i < values.length; i++) {
      result = result.replace(`{${i}}`, values[i]);
    }
    return result;
  }
}
